import React, { useState, useEffect } from 'react';

const CompanyCard = ({ selected, onClaimGenerated, externalClaimId }) => {
    const [fetchedClaimId, setFetchedClaimId] = useState(null);

    // Derive the displayed claim ID from prop (live) or fetched value (after reload)
    const claimId = externalClaimId || fetchedClaimId;

    const CLAIMS_API_BASE_URL = 'https://fnolbackend.alphatorana.com/api';

    // Fetch existing claim on load to support refresh persistence
    useEffect(() => {
        setFetchedClaimId(null);

        const fetchExistingClaim = async () => {
            if (!selected?.id) return;

            try {
                const response = await fetch(`${CLAIMS_API_BASE_URL}/claims/${selected.id}`, {
                    headers: {
                        'ngrok-skip-browser-warning': 'true'
                    }
                });

                if (response.ok) {
                    const data = await response.json();
                    setFetchedClaimId(data.claim_id);
                    if (onClaimGenerated) {
                        onClaimGenerated(data.claim_id);
                    }
                } else if (response.status !== 404) {
                    console.error('Error fetching claim:', response.statusText);
                }
            } catch (err) {
                console.error('Error fetching claim:', err);
            }
        };

        fetchExistingClaim();
    }, [selected?.id, onClaimGenerated]);

    return (
        <section className="card mb-1" style={{ borderRadius: '10px' }}>
            <div className="card-body">
                <div className="row align-items-center g-3">
                    <div className="col-12 col-md-auto">
                        <div className='ps-2'>
                            <div className="h4 mb-1 fw-bold">{selected?.company || "Company"}</div>
                            <div className="d-flex align-items-center gap-2">
                                <div className="small text-muted fw-semibold">{selected?.id ?? "FNOL-1234567890"}</div>
                                {claimId && <div className="small text-muted fw-semibold">|</div>}
                                <div className="small fw-bold" style={{ color: '#006BB3' }}>{claimId || ""}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CompanyCard;

